module.exports = __webpack_public_path__ + "static/img/10.40011e44.png";